/**
 * CENTRALIZED DOMICILIATION PERMISSIONS ACTIONS
 * 
 * Redux actions for managing domiciliation permissions state
 * All actions use the centralized ACL module
 */

import { checkDomiciliationPermission } from '../../acl/domiciliation';

// Action types
export const CHECK_DOMICILIATION_PERMISSION_REQUEST = 'CHECK_DOMICILIATION_PERMISSION_REQUEST';
export const CHECK_DOMICILIATION_PERMISSION_SUCCESS = 'CHECK_DOMICILIATION_PERMISSION_SUCCESS';
export const CHECK_DOMICILIATION_PERMISSION_FAILURE = 'CHECK_DOMICILIATION_PERMISSION_FAILURE';
export const CLEAR_DOMICILIATION_PERMISSION = 'CLEAR_DOMICILIATION_PERMISSION';

/**
 * Check domiciliation permission
 * This is the main action that components will dispatch
 */
export function fetchDomiciliationPermission(specialToken = null) {
  return async (dispatch) => {
    // Start loading
    dispatch({
      type: CHECK_DOMICILIATION_PERMISSION_REQUEST,
      payload: { specialToken: !!specialToken }
    });

    try {
      // Use centralized ACL module
      const result = await checkDomiciliationPermission(specialToken);

      // Success
      dispatch({
        type: CHECK_DOMICILIATION_PERMISSION_SUCCESS,
        payload: {
          canView: result.canView,
          userType: result.userType,
          hasToken: !!specialToken
        }
      });

      return result;

    } catch (error) {
      // Failure
      dispatch({
        type: CHECK_DOMICILIATION_PERMISSION_FAILURE,
        payload: {
          error: error.message || 'Error al verificar permisos',
          hasToken: !!specialToken
        }
      });

      throw error;
    }
  };
}

/**
 * Clear domiciliation permission from state
 * Useful when user logs out or permission needs to be rechecked
 * 
 * @returns {Object} Redux action
 */
export function clearDomiciliationPermission() {
  return {
    type: CLEAR_DOMICILIATION_PERMISSION
  };
}

/**
 * Set domiciliation permission directly
 * Useful for testing or when permission is known
 * 
 * @param {boolean} canView - Whether user can view domiciliation
 * @param {string} userType - Type of user
 * @returns {Object} Redux action
 */
export function setDomiciliationPermission(canView, userType) {
  return {
    type: CHECK_DOMICILIATION_PERMISSION_SUCCESS,
    payload: {
      canView,
      userType,
      hasToken: false
    }
  };
}




// WEBPACK FOOTER //
// ./src/redux/actions/domiciliationPermissionsActions.js